import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const scrollTo = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

const FinalCTA = () => {
  return (
    <section
      data-testid="final-cta-section"
      className="relative py-32 bg-[#0A0A0A] text-white overflow-hidden"
    >
      <div className="absolute inset-0 opacity-40 pointer-events-none">
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[700px] h-[700px] bg-blue-600/30 blur-3xl rounded-full" />
      </div>
      <div className="absolute inset-0 opacity-[0.05] [background-image:linear-gradient(to_right,#fff_1px,transparent_1px),linear-gradient(to_bottom,#fff_1px,transparent_1px)] [background-size:64px_64px] pointer-events-none" />

      <div className="relative mx-auto max-w-4xl px-6 text-center">
        <h2 className="font-display text-5xl md:text-7xl lg:text-[96px] font-semibold tracking-[-0.03em] leading-[0.98]">
          Start <span className="italic font-light text-zinc-400">talking</span> to your stuff.
        </h2>
        <p className="mt-7 text-zinc-400 text-lg md:text-xl max-w-2xl mx-auto">
          Join the waitlist. Be first when VoloTag starts answering back.
        </p>
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Button
            data-testid="final-cta-waitlist"
            onClick={() => scrollTo("waitlist")}
            className="rounded-full bg-white text-black hover:bg-zinc-200 h-[52px] px-8 text-[15px] font-medium cta-shine shadow-[0_12px_30px_-8px_rgba(255,255,255,0.25)] hover:-translate-y-[1px] transition"
          >
            Join Waitlist
            <ArrowRight className="ml-1.5 w-4 h-4" />
          </Button>
          <Button
            data-testid="final-cta-early"
            onClick={() => scrollTo("interaction")}
            variant="ghost"
            className="rounded-full h-[52px] px-7 text-zinc-300 hover:text-white hover:bg-white/5"
          >
            See it respond →
          </Button>
        </div>
        <p className="mt-6 text-xs tracking-[0.2em] uppercase text-zinc-500">
          No app · No searching · Just response
        </p>
      </div>
    </section>
  );
};

export default FinalCTA;
